/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_VerifyInputs */

const en_delete_account_verify = /** @type {(inputs: Delete_Account_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify`)
};

const es_delete_account_verify = /** @type {(inputs: Delete_Account_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar`)
};

const ar_delete_account_verify = /** @type {(inputs: Delete_Account_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحقق`)
};

/**
* | output |
* | --- |
* | "Verify" |
*
* @param {Delete_Account_VerifyInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_verify = /** @type {((inputs?: Delete_Account_VerifyInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_VerifyInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_verify(inputs)
	if (locale === "es") return es_delete_account_verify(inputs)
	return ar_delete_account_verify(inputs)
});